import I18n from '@legacy/js/vendor/I18n';
import Helpers from '@legacy/js/helpers';

const i18n = new I18n();
const helpers = new Helpers();

const trans = (key, replace = {}) => {
	if (!i18n) return key;
	return i18n.trans(key, replace);
};

const transUcfirst = (key, replace = {}) => {
	if (!helpers) {
		return key;
	}
	return helpers.ucfirst(i18n.trans(key, replace));
};

const transChoice = (key, count = 1) => {
	if (!helpers) {
		return key;
	}
	return i18n.trans_choice(key, count);
};

const transChoiceUcFirst = (key, count = 1) => {
	return helpers.ucfirst(transChoice(key, count));
};

const transTagLabel = (label, sportName, tagType) => {
	if (tagType === 'custom') {
		return label;
	}
	// if the label includes a dot, it's a custom clip tag with a custom name
	// which we don't want to translate
	if (label.indexOf('.') !== -1) {
		return label;
	}

	if (!i18n) return label;

	const keys = {
		wanted:   `sports.${sportName}.tags.${label}`,
		fallback: `tag.names.generic.${label}`,
	};

	let result = i18n.trans(keys.wanted);
	if (result !== keys.wanted) return result;
	result = i18n.trans(keys.fallback);
	if (result !== keys.fallback) return result;
	return label;
};

export default {
	trans,
	transChoice,
	transChoiceUcFirst,
	transUcfirst,
	transTagLabel,
};
export { trans, transChoice, transChoiceUcFirst, transUcfirst, transTagLabel };
